<template>
  <section class="login">
    <div class="login-content">
      <h1><img src="/images/grabe_logo_red.svg" alt="Grabe"></h1>
      <form action="" @submit.prevent="login(email, password)">
        <el-input placeholder="Email" v-model="email"></el-input>
        <el-input placeholder="Mot de passe" v-model="password" type="password"></el-input>
        <button class="el-button" type="submit">Connexion</button>
      </form>
    </div>
  </section>
</template>

<script>
import auth from '@/services/auth';

export default {
  name: 'login',
  components: {
  },
  data() {
    return {
      email: null,
      password: null,
    };
  },
  mounted() {
  },
  methods: {
    async login(email, pass) {
      try {
        await auth.login(email, pass);
        this.$router.push({ name: 'spaces' });
      } catch (e) {
        this.$notify.error({
          title: 'Connexion impossible',
          message: 'Votre email et/ou mot de passe sont incorrects.',
        });
      }
    },
  },
};
</script>

<style lang="sass">
.login
  position: fixed
  top: 0
  left: 0
  bottom: 0
  right: 0
  z-index: 1000
  background: #ff3c48 url('/images/home.jpg') right center
  background-size: cover

  .login-content
    position: absolute
    top: 50%
    left: 0
    padding: 2.7rem 3rem 3.7rem
    max-width: 420px
    transform: translateY(-55%)
    background: white
    border-radius: 0 4px 4px 0
    h1
      display: block
      img
        display: inline-block
        max-width: 250px
    .el-input
      margin: 1rem 0
      input
        background: #FAFAFA
    button
      margin-top: 2rem
      background: #ff3c48
      color: white
</style>
